<template>
  <div>
    <v-container fluid class="py-6">
      <div class="d-sm-flex justify-between">
        <v-btn
            elevation="0"
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-secondary
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
            color="#5e72e4"
            small
        >ADD USER</v-btn
        >
        <div v-if="false" class="d-flex ms-auto">
          <v-menu transition="slide-y-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                  font-weight-bold
                  text-uppercase
                  btn-default btn-outline-default
                  py-2
                  px-6
                  me-2
                "
                  color="transparent"
                  small
              >
                Filter By
                <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
              </v-btn>
            </template>

            <v-list class="py-0">
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Approved
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Pending
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Rejected
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr class="horizontal dark" />
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-danger ls-0 font-weight-600 mb-0"
                  >
                    Remove Filter
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon>ni ni-archive-2 me-1</v-icon>
            Export CSV
          </v-btn>
          <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon>ni ni-archive-2 me-1</v-icon>
            Export PDF
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl">
            <div>
              <v-card class="card-shadow border-radius-xl mt-6">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                      :headers="headers"
                      :items="returns"
                      :search="search"
                      class="table"
                      :page.sync="page"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      :items-per-page="itemsPerPage"
                      mobile-breakpoint="0"
                  >
                    <template v-slot:top>
                      <v-toolbar flat height="80">
                        <v-row>
                          <v-col cols="12" md="5">
                            <v-text-field
                                hide-details
                                class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                                dense
                                flat
                                filled
                                solo
                                height="43"
                                v-model="search"
                                placeholder="Search"
                            >
                              <template slot="prepend-inner">
                                <v-icon color="#adb5bd" size=".875rem"
                                >fas fa-search</v-icon
                                >
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.id="{ item }">
                      <div class="d-flex align-center">
                        <v-checkbox
                            :ripple="false"
                            v-model="item.checkbox"
                            color="#141727"
                        ></v-checkbox>
                        <span class="my-2 text-xs text-body font-weight-bold">{{
                            item.id
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.date="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.date
              }}</span>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <div class="d-flex align-center">
                        <v-btn
                            :ripple="false"
                            icon
                            outlined
                            rounded
                            width="25px"
                            height="25px"
                            class="me-2"
                            :class="
                  item.statusIcon == 'fas fa-check'
                    ? 'border-success'
                    : 'border-warning'
                "
                        >
                          <v-icon
                              size="8"
                              :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'text-success'
                      : 'text-warning'
                  "
                          >
                            {{ item.statusIcon }}
                          </v-icon>
                        </v-btn>
                        <span class="text-body text-xs">{{ item.status }}</span>
                      </div>
                    </template>

                    <template v-slot:item.customer="{ item }">
                      <div class="d-flex align-center">
                        <v-avatar size="24" class="me-2" v-if="item.customerImg">
                          <v-img :src="item.customerImg"></v-img>
                        </v-avatar>

                        <v-avatar size="24" class="me-2 bg-gradient-default" v-else>
                          <span class="text-white text-xs">{{ item.customer[0] }}</span>
                        </v-avatar>
                        <span class="text-body text-xs font-weight-bold">{{
                            item.customer
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.product="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.product
              }}</span>
                    </template>

                    <template v-slot:item.revenue="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.revenue
              }}</span>
                    </template>

                    <template v-slot:item.action="{ item }">
                      <v-btn
                          @click="goTo()"
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                          :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                      >{{item.statusIcon == 'fas fa-check'
                          ? 'View'
                          : 'View'}}</v-btn
                      >
                    </template>

                    <template v-slot:item.invoice="{ item }">
                      <v-btn
                          color="#fff"
                          class="text-dark font-weight-bolder px-1 shadow-0"
                          small
                          simple
                      >
                        <v-icon size="18" class="rotate-180"
                        >fas fa-file-pdf text-lg me-1</v-icon
                        >
                        Pdf
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="card-padding">
                  <v-row>
                    <v-col cols="6" lg="3" class="d-flex align-center">
                      <span class="text-body me-3 text-sm">Items per page:</span>
                      <v-text-field
                          hide-details
                          type="number"
                          outlined
                          min="-1"
                          max="15"
                          background-color="rgba(255,255,255,.9)"
                          color="rgba(0,0,0,.6)"
                          light
                          :value="itemsPerPage"
                          @input="itemsPerPage = parseInt($event, 10)"
                          placeholder="Items per page"
                          class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="ml-auto d-flex justify-end">
                      <v-pagination
                          prev-icon="fa fa-angle-left"
                          next-icon="fa fa-angle-right"
                          class="pagination"
                          color="#cb0c9f"
                          v-model="page"
                          :length="pageCount"
                          circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "Returns-List",
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      returns: [],
      search: "",
      headers: [
        {
          text: "Email",
          value: "email",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Firstname",
          value: "firstname",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Lastname",
          value: "lastname",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Role",
          value: "role",
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
    };
  },
  created () {
    this.getUsers()
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    ...mapState(['base_url']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  methods: {
    getUsers(){
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/auth/get-admin-users/', { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.returns = res.data
              console.log(this.returns)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    goTo(){
      this.$router.push("/admin-returns-view");
    }
  },
};
</script>
